import { logException, redirectToErrorPage } from './Utils';
import { getProduct } from './Product';

let processedProducts = {};
let endpointIdProductIdMap = {};

// methods for processedProducts cache
export const setProductCache = (key, value) => {
  processedProducts[key] = value;
};

export const getCachedProduct = (key) => processedProducts[key];

export const deleteProductCache = (id) => {
  if (processedProducts[id]) {
    delete processedProducts[id];
  }
};

export const clearCache = () => (processedProducts = {});

// method for endpointIdProductIdMap cache
export const resetEndpointProductIdMapCache = () => (endpointIdProductIdMap = {});

export const getProductIdFromEndpointId = ({ productId }) => {
  if (endpointIdProductIdMap[productId]) {
    return endpointIdProductIdMap[productId];
  }

  const product = getProduct(productId);

  if (!product) {
    logException("Product doesn't exist in getProductIdFromEndpointId", {
      productId
    });
    redirectToErrorPage();
    return;
  }

  if (product && !product.isVariant()) {
    endpointIdProductIdMap[productId] = productId;
    return productId;
  }

  const parentProductId = product.parentProductId;
  const parentProduct = getProduct(parentProductId) || {};
  const { defaultVariantId } = parentProduct;

  endpointIdProductIdMap[productId] = defaultVariantId;
  return defaultVariantId;
};

export const updateProductImageDimensionsInCache = ({
  productId,
  fromCustomPage,
  imageId,
  imageHeight,
  imageWidth
}) => {
  const product = getProduct(productId, fromCustomPage);
  if (product) {
    const { pictures = {} } = product;
    const pictureValues = Object.values(pictures);
    const picture = pictureValues.find((picture) => picture.pictureId === imageId);
    if (picture && !picture.height && !picture.width && imageHeight && imageWidth) {
      setProductCache(productId, {
        ...product,
        pictures: {
          ...product.pictures,
          [imageId]: {
            ...product.pictures[imageId],
            height: imageHeight,
            width: imageWidth
          }
        }
      });
    }
  }
};
